/* eslint-disable @typescript-eslint/naming-convention */
export enum ScheduleType {
    None = 'None',
    Minute = 'Minute',
    Hour = 'Hour',
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Year = 'Year',
    OneTime = 'OneTime',
};
